(() => {
  const name = 'ga-local-shipping-threshold';
  if (customElements.get(name)) return;

  customElements.define(name, class extends HTMLElement {
    connectedCallback() {
      const currency = window.Shopify?.currency;
      const amount = Number(this.dataset.amount);
      const rate = Number(currency?.rate);
      const target = this.dataset.currency;
      const template = this.dataset.template;

      if (this.dataset.sourceCurrency !== 'SEK' ||
          currency?.active !== target ||
          !Number.isFinite(amount) || amount <= 0 ||
          !Number.isFinite(rate) || rate <= 0 ||
          !template?.includes('__amount__')) return;

      try {
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: target
        });
        const bufferedAmount = amount * rate * 1.05;
        const increment = target === 'EUR' ? 5 : 1;
        const converted = Math.ceil(bufferedAmount / increment - 1e-8) * increment;
        if (!Number.isFinite(converted) || converted <= 0) return;
        this.textContent = template.replace('__amount__', formatter.format(converted));
      } catch {
        return;
      }
    }
  });
})();
